
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d615a3ea&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./customprice.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./customprice.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-d615a3ea!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./customprice.vue"),
  /* scopeId */
  "data-v-d615a3ea",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/system/customprice.vue
// module id = 1601
// module chunks = 3